import { render, staticRenderFns } from "./TakeQueue.vue?vue&type=template&id=4c72a63a&scoped=true&"
import script from "./TakeQueue.vue?vue&type=script&lang=js&"
export * from "./TakeQueue.vue?vue&type=script&lang=js&"
import style0 from "./TakeQueue.vue?vue&type=style&index=0&id=4c72a63a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c72a63a",
  null
  
)

export default component.exports